import { Stack } from 'expo-router';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';
import { removeFirstScreenFromTabHistory } from '../../../utils/remove-first-screen-from-tab-history';

const rewardsHeader = getScreenTitleHeader({ closeBehavior: 'tabHistory' });

const modalOptions = {
  presentation: 'containedTransparentModal' as const,
  headerShown: false,
  contentStyle: { backgroundColor: 'transparent' },
  animation: 'none' as const,
  freezeOnBlur: false,
};

export default function RewardsTabLayout() {
  return (
    <Stack screenOptions={{ header: rewardsHeader }}>
      <Stack.Screen name="index" options={{ title: 'Rewards' }} />
      <Stack.Screen name="details" options={{ title: 'Rewards' }} />
      <Stack.Screen
        name="history"
        options={({ route }) => ({
          title: 'Rewards History',
          contentStyle: { backgroundColor: 'white' },
          animation: route.params?.direct ? 'none' : 'default',
        })}
        listeners={({ navigation }) => ({
          blur: () => {
            queueMicrotask(() => removeFirstScreenFromTabHistory(navigation));
          },
        })}
      />
      <Stack.Screen name="birthday" options={modalOptions} />
      <Stack.Screen name="list/[rewardId]" options={{ title: 'Rewards Details' }} />
      <Stack.Screen name="offers" options={{ title: 'Offers' }} />
    </Stack>
  );
}
